// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"66":"103e9db8","93":"103e9db8","324":"103e9db8","522":"4e56eb62"}[chunkId] + ".chunk.css";
};